import {combineReducers} from "redux";


export default combineReducers({
    //Add reducers here that are imported from reducers
});
